import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IsfShortModel } from '@data-layer/models/isf';
import { Router } from '@angular/router';
import { enumCompanyPlacement } from '@enum/enumCompanyPlacement';
import { MarineInsuranceAvailabilityService } from '@shared/marine-insurance-shared/services';

@Component({
  selector: 'isf-detail',
  templateUrl: './isf-detail.component.html',
  styleUrls: ['./isf-detail.component.scss'],
})
export class IsfDetailComponent {
  @Input() public isf: IsfShortModel;
  @Output() public update: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public editInternalNotes: EventEmitter<void> = new EventEmitter<void>();

  public enumCompanyPlacement: typeof enumCompanyPlacement = enumCompanyPlacement;

  constructor(private router: Router, private marineInsuranceAvailabilityService: MarineInsuranceAvailabilityService) {}

  public onUpdate(e: any): void {
    this.update.emit(e);
  }

  public createEntry(): void {
    this.router.navigate(['/entry-summary', 'start'], { queryParams: { isfReferenceNumber: this.isf.referenceNumber } });
  }

  public viewEntry(): void {
    this.router.navigate(['/entry-summary', this.isf.entrySummaryReferenceNumber]);
  }

  public openInternalNotes(): void {
    this.editInternalNotes.emit();
  }

  public get isValidShipment(): boolean {
    return (!!this.isf.houseBill.carrier && !!this.isf.houseBill.number) || (!!this.isf.masterBill.carrier && !!this.isf.masterBill.number);
  }

  public get billOfLadingInfo(): string {
    const parts: string[] = [];
    if (this.isf?.masterBill) {
      const masterBillInfo = (this.isf.masterBill.carrier || '') + (this.isf.masterBill.number || '');
      if (masterBillInfo) {
        parts.push(masterBillInfo);
      }
    }
    if (this.isf?.houseBill) {
      const houseBillInfo = (this.isf.houseBill.carrier || '') + (this.isf.houseBill.number || '');
      if (houseBillInfo) {
        parts.push(houseBillInfo);
      }
    }
    return parts.join('/');
  }

  public get isShowInsuranceIndicator(): boolean {
    return this.marineInsuranceAvailabilityService.isShowIndicatorForIsf(this.isf);
  }
}
